/**
 * All settings (Figma 09 · Phone / Tablet · 01 All settings): the compact
 * shell's way into Settings, one grouped card with a line under every page.
 */
import { Link } from "react-router";
import { ChevronRight } from "lucide-react";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { visibleSections } from "./SettingsNav";
import { useSelectedBrand } from "./parts/scope";

export default function AllSettingsIndex() {
  const { user, selectedOrganization } = useCurrentUser();
  const { brand } = useSelectedBrand();
  const sections = visibleSections(selectedOrganization?.role ?? null);

  const scopeName = (scope: string) =>
    scope === "you"
      ? user?.name || user?.email
      : scope === "workspace"
        ? selectedOrganization?.organization.name
        : brand?.name;

  return (
    <div className="mx-auto flex w-full max-w-[760px] flex-col gap-5">
      <h1 className="font-display text-[34px] font-semibold leading-none tracking-normal text-co-text">Settings</h1>
      <div className="flex flex-col gap-1 rounded-panel bg-co-surface p-2">
        {sections.map((section) => (
          <div key={section.scope} className="flex flex-col">
            <p className="px-3 pb-1 pt-3 text-[12px] font-semibold text-co-muted">
              {section.title}
              {scopeName(section.scope) ? ` · ${scopeName(section.scope)}` : ""}
            </p>
            {section.items.map((item) => (
              <Link
                key={item.id}
                to={`.?page=${item.id}`}
                className="unstyled-link flex items-center gap-3 rounded-row px-3 py-2.5 transition-colors hover:bg-co-hover"
              >
                <span className="flex min-w-0 flex-1 flex-col gap-0.5">
                  <span className="text-[14px] font-semibold text-co-text">{item.label}</span>
                  <span className="text-[12px] leading-[1.4] text-co-muted">{item.hint}</span>
                </span>
                <ChevronRight aria-hidden className="size-3.5 shrink-0 text-co-faint" />
              </Link>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
